// The single judge of what counts as a searchable tracking, and it is deliberately almost nothing:
// trim, then a floor of three characters.
//
// **No shape validation, on purpose.** A tracking number has no shape the panel can assert — it is
// alphanumeric, its length varies by carrier, and some carriers mix in separators. Any regex here
// would reject legitimate trackings, and the agent would read that rejection as «this parcel does
// not exist» while holding it in their hand.
//
// The floor is measured on the TRIMMED term, and the trimmed term is what gets sent: the server
// trims before validating its own 3-character floor, so measuring the raw string would let
// «  ab  » through the panel and 400 on the far side. One string, measured once, sent once.
//
// Returns the term to search with, or null when there is nothing to search.
const MIN_LENGTH = 3;

export function detectTracking(input: string): string | null {
  const trimmed = input.trim();
  if (trimmed.length < MIN_LENGTH) return null;

  return trimmed;
}
